import _ from 'lodash';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useMenuSections from 'src/dispensary/hooks/use-menu-sections';
import { useActiveScheduledItems } from 'src/dispensary/hooks/use-active-scheduled-items';

/**
 * Hook to fetch menu sections for the current dispensary with schedule filtering.
 *
 * Uses the separate useMenuSections hook which handles user segment fetching
 * independently from the main dispensary data.
 */
export default function useDispensaryMenuSections() {
  const { dispensary, dispensaryId, loading: dispensaryLoading } = useDispensary();

  const {
    menuSections: rawMenuSections,
    loading: menuSectionsLoading,
    error,
    ...menuSectionsApolloValues
  } = useMenuSections({
    dispensaryId: dispensary?.id,
    skip: !dispensary?.id,
  });

  // Combine loading states: we're loading if either the dispensary OR menu sections are loading
  // This ensures consumers don't see loading: false with empty menuSections while waiting for dispensary data
  const loading = dispensaryLoading || menuSectionsLoading;

  const allMenuSections = _.sortBy(rawMenuSections, 'position');

  const menuSections = useActiveScheduledItems({
    items: allMenuSections ?? [],
    getSchedule: (section) => {
      // Only collection sections have schedules
      if (section?.sectionType !== 'COLLECTION') {
        return null;
      }
      return section.collectionSchedule;
    },
    dispensaryTimezone: dispensary?.timezone,
    enablePolling: true,
  });

  return {
    menuSections,
    loading,
    error,
    dispensaryId,
    ...menuSectionsApolloValues,
  };
}
